<template>
  <div class="insights-layout">
    <LayoutInsightsHeader class="insights-layout__header">
      <template #page-heading>
        <slot name="page-heading"></slot>
      </template>

      <template #page-filter>
        <KeepAlive>
          <slot name="page-filter"></slot>
        </KeepAlive>
      </template>
    </LayoutInsightsHeader>

    <LayoutInsightsNav class="insights-layout__nav"/>

    <main
      class="insights-layout__main"
      :class="{ 'insights-layout__main--loading': isLoading }"
    >
      <slot name="main"></slot>

      <Transition name="transition-fade">
        <div
          v-show="isLoading"
          class="insights-layout__main__loader"
        >
          <BaseLoaderDefault/>
        </div>
      </Transition>
    </main>
  </div>
</template>

<script>
import LayoutInsightsHeader from '@/components/layout/insights/LayoutInsightsHeader'
import LayoutInsightsNav from '@/components/layout/insights/LayoutInsightsNav'
import BaseLoaderDefault from '@/components/base/BaseLoaderDefault'
import { mapState } from 'vuex'
import axios from 'axios'

import '@/views/DashboardDefault.vue' // Hack for DateRangePicker (?) - WIP

export default {
  name: 'LayoutInsights',

  components: {
    LayoutInsightsHeader,
    LayoutInsightsNav,
    BaseLoaderDefault
  },

  computed: {
    ...mapState('base', ['isLoading'])
  },

  created () {
    axios.defaults.headers.common['Authorization'] = `Bearer ${this.$auth.token()}`;
  }
}
</script>

<style lang="scss">
.insights-layout {
  @import '~@/styles/main';

  @extend %global;

  $gap: map-get($layout-insights, 'gap');
  $gap-bigger: map-get($layout-insights, 'gap-bigger');
  $nav-width: map-get($layout-insights, 'nav-width');

  display: grid;
  min-height: 100vh;
  grid-template: {
    columns: $nav-width 1fr;
    rows: auto 1fr;
    areas:
      'nav header'
      'nav main';
  }
  align-content: start;

  &__header {
    grid-area: header;
  }

  &__nav {
    grid-area: nav;
  }

  &__main {
    grid-area: main;
    position: relative;
    align-self: auto;
    overflow: hidden;
    padding: 0 $gap-bigger $gap !important;

    &--loading {
      > * {
        display: none;
      }
    }

    &__loader {
      z-index: 80;
      position: relative;
      display: flex;
      height: 100%;
      justify-content: center;
      align-items: center;
      background: map-get($colors-util, 'lightest');
    }
  }
}
</style>
